<div class="vehicle-list" *transloco="let t">
	<op-back-link [green]="false" class="op-mt-20 op-black" [opRoute]="'offerStatus'" id="vehicleBack">{{
		t('VEHICLE.returnToOffers')
	}}</op-back-link>

	<op-masthead [title]="t('VEHICLE.title')"></op-masthead>

	<op-content-container class="content" *ngIf="vehicles.length">
		<div class="op-body-1-font info-row">
			<div>{{ t('VEHICLE.manyVehicles') }}</div>
			<div class="op-ml-5">
				<a href="" onclick="return false" class="" id="infoToolTip" (click)="show = !show">
					<mat-icon [matTooltipShowDelay]="1000" id="infoTipIcon" svgIcon="op-info"> </mat-icon>
				</a>
			</div>
		</div>
		<div role="status" class="info-tip op-micro-font" *ngIf="show">
			<span id="infoTipContent" [innerHTML]="t('VEHICLE.toolTip')"></span>
		</div>
		<div class="op-body-1-font op-mt-5 op-mb-10">
			{{ t('VEHICLE.checkEligibility') }}
		</div>

		<div *ngFor="let vehicle of vehicles" class="vehicle-details">
			<div class="vehicle-details-row">
				<mat-icon svgIcon="op-vehicle"></mat-icon>
				<div class="op-black-bold">{{ vehicle.modelYear }} {{ vehicle.makeText }} {{ vehicle.modelText }}</div>
			</div>
			<div class="op-center op-mt-20">
				<button
					mat-flat-button
					color="secondary"
					id="selectVehicle"
					type="button"
					[opTagClick]="'vg vehicle select'"
					(click)="selectVehicle(vehicle.vin, vehicle.vendorName, vehicle.vendorVehicleId)"
				>
					{{ t('VEHICLE.select') }}
				</button>
			</div>
		</div>
		<div class="vehicle-details">
			<div class="vehicle-details-row">
				<mat-icon svgIcon="op-vehicle-add"></mat-icon>
				<div class="op-black-bold">
					<a
						href=""
						onclick="return false"
						class=""
						id="tryAnotherVehicle"
						[opTagClick]="'tryAnotherVehicle'"
						(click)="navigate()"
					>
						{{ t('VEHICLE.tryAnotherVehicle') }}
					</a>
				</div>
			</div>
		</div>

		<div class="op-mt-40">
			<div id="faqSubtitle" class="op-header-3-font">
				{{ t('VEHICLE.faq') }}
			</div>

			<op-expansion-panel
				id="whyMyCarPanel"
				[titleBold]="false"
				[title]="t('VEHICLE.whyMyCarQ')"
				[opTagClick]="'Why are you asking about my car'"
			>
				<p>{{ t('VEHICLE.whyMyCarA') }}</p>
			</op-expansion-panel>

			<op-expansion-panel
				id="whatAreRequirementPanel"
				[titleBold]="false"
				[title]="t('VEHICLE.whatAreRequirementsQ')"
				[opTagClick]="'What are the vehicle requirements'"
			>
				<ul>
					<li>{{ t('VEHICLE.whatAreRequirementsA1') }}</li>
					<li class="op-mt-20">{{ t('VEHICLE.whatAreRequirementsA2') }}</li>
					<li class="op-mt-20">
						{{ t('VEHICLE.whatAreRequirementsA3', { customerStateName: customerStateName }) }}
					</li>
					<li class="op-mt-20">
						{{ t('VEHICLE.whatAreRequirementsA4', { numOfDaysToRenewRegistration: numOfDaysToRenewRegistration }) }}
					</li>
					<li class="op-mt-20">{{ t('VEHICLE.whatAreRequirementsA5') }}</li>
				</ul>
			</op-expansion-panel>

			<op-expansion-panel id="whereToFindVinPanel" [titleBold]="false" [title]="t('VEHICLE.whereFindVinQ')">
				<p>{{ t('VEHICLE.whereFindVinA') }}</p>
			</op-expansion-panel>

			<op-expansion-panel id="vehicleTypesPanel" [titleBold]="false" [title]="t('VEHICLE.vehicleTypesQ')">
				<p [innerHTML]="t('VEHICLE.vehicleTypesA1')"></p>
				<p class="op-mt-20" [innerHTML]="t('VEHICLE.vehicleTypesA2')"></p>
				<p class="op-mt-20" [innerHTML]="t('VEHICLE.vehicleTypesA3')"></p>
			</op-expansion-panel>
		</div>
	</op-content-container>
</div>
